import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { makeStyles } from "@material-ui/core/styles";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";

const useStyles = makeStyles({
  root: {
    maxWidth: "50%",
  },
});

const Notice = (props) => {
  const [details, setDetails] = useState(props.details);

  const classes = useStyles();

  useEffect(() => {
    setDetails(props.details);
  }, [props.details]);

  const handleClose = () => {
    setDetails({ ...details, open: false });
  };

  function getClassName() {
    if (props.width === "half") {
      return classes.root;
    }
    return null;
  }

  return createPortal(
    <Snackbar
      className={getClassName()}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      open={details.open}
      autoHideDuration={5000}
      onClose={handleClose}
    >
      <Alert elevation={5} variant="filled" onClose={handleClose} severity={details.kind}>
        {details.message}
      </Alert>
    </Snackbar>,
    document.body
  );
};

export default Notice;
